import type { ApiClient } from "./client";

export interface SellableItem {
  id: string; kind: string; name: string; sku: string | null; price: number; priceIncludesTax: boolean; taxRateBp: number;
  hsnSac: string | null; durationDays: number | null; sessionsTotal: number | null;
}
/** Branch-scoped picker list (`billing:add`). `price` is displayed as the catalogue states it; totals come from the preview. */
export const fetchSellable = (c: ApiClient, branchId: string) =>
  c.get<{ branchId: string; on: string; items: SellableItem[] }>("/catalogue/sellable", { branchId }).then((r) => r.items);
